import { useState } from "react";

export default function usePlan() {
    const [currentPlan, setCurrentPlan] = useState<Agent.Plan>();
    const setFocusedPlan = async (plan?: Agent.Plan) => {
        setCurrentPlan(plan);
    };
    return { currentPlan, setFocusedPlan };
}
